export interface Kode {
  kode: number;
  tekst: string;
  beskrivelse: string;
}

export const anvgen: Kode[] = [
  {
    kode: 11,
    tekst: 'Boligområde',
    beskrivelse:
      "Område som er planlagt som boligområde. I boligområder er der ud over boliger mulighed for lokal detailhandel, lokal privat og offentlig service samt fællesanlæg mm, som er en 'naturlig del' af et boligområde.",
  },
  {
    kode: 21,
    tekst: 'Blandet bolig og erhverv',
    beskrivelse:
      'Område, hvor der er planlagt mulighed for både bolig og erhverv. Der vil normalt være registreret specifikke anvendelseskategorier for både boliger og erhverv eller der kan være tale om et Landsbyområde.',
  },
  {
    kode: 31,
    tekst: 'Erhvervsområde',
    beskrivelse:
      "Område som er planlagt som erhvervsområde. I erhvervsområder er der ud over erhverv mulighed for lokal detailhandel, boliger, lokal service mm, som er en 'naturlig del' af et erhvervsområde.",
  },
  {
    kode: 51,
    tekst: 'Rekreativt område',
    beskrivelse:
      'Område som er planlagt som rekreativt område. Omfatter alle fritids- og turistanlæg og rekreative grønne områder i og uden for byerne.',
  },
  {
    kode: 61,
    tekst: 'Sommerhusområde',
    beskrivelse: 'Omfatter arealer der er planlagt til sommerhusområder.',
  },
  {
    kode: 71,
    tekst: 'Område til offentlige formål',
    beskrivelse:
      'Område som er planlagt til offentlige formål. Omfatter arealer udlagt til uddannelses-, sundheds-, kulturelle, administrative, samt sociale formål.',
  },
  {
    kode: 91,
    tekst: 'Landområde',
    beskrivelse:
      'Område som er planlagt til jordbrugsområder, større naturområder, industrielt landbrug, militære områder og områder til råstofindvinding.',
  },
  {
    kode: 96,
    tekst: 'Andet',
    beskrivelse:
      'Kategorien andet er en “opsamlingskasse” for områder, hvor den planlagte, overordnede anvendelse ikke passer ind i de øvrige katagorier. Der bør være tale om ganske få områder.',
  },
  {
    kode: 41,
    tekst: 'Centerområde og butikker',
    beskrivelse:
      'Område som planlægges til centerformål og butikker. Omfatter bl.a. Bymidter, bycentre, lokalcentre, aflastningcentre samt forskellige former for butikker og publikumsorienteret service.',
  },
  {
    kode: 81,
    tekst: 'Tekniske anlæg og Trafik anlæg',
    beskrivelse:
      'Område som er planlagt til tekniske anlæg og trafik anlæg. Omfatter trafikanlæg og kommunikationsanlæg, forsyningsanlæg og andre tekniske anlæg herunder miljøanlæg, rensningsanlæg, deponeringsanlæg, m.v.',
  },
  {
    kode: 0,
    tekst: 'Ukendt',
    beskrivelse: 'Kode ikke sat',
  },
];

export function getAnvgenForKode(kode: number): Kode | undefined {
  return anvgen.find(function(a) {
    return a.kode === kode;
  });
}

export const anvspec: Kode[] = [
  {
    kode: 1100,
    tekst: 'Boligområde',
    beskrivelse:
      'Uspecificeret boligområde. Anvendes når planen ikke udpeger specifikke boligtyper',
  },
  {
    kode: 1110,
    tekst: 'Åben-lav boligbebyggelse',
    beskrivelse:
      'Fritliggende boligbebyggelse med en eller to boliger til helårsbeboelse (villaer, parcelhuse)',
  },
  {
    kode: 1120,
    tekst: 'Tæt-lav boligbebyggelse',
    beskrivelse:
      'Dobbelthuse, kædehuse, rækkehuse, gårdhuse og lign. helt eller delvis sammenbyggede enfamiliehuse med lodret lejlighedsskel.',
  },
  {
    kode: 1130,
    tekst: 'Etageboligbebyggelse',
    beskrivelse:
      'Beboelsesbygning i to etager eller derover med vandret lejlighedsskel.',
  },
  { kode: 1140, tekst: 'Blandet boligområde', beskrivelse: '' },
  {
    kode: 1150,
    tekst: 'Almene boliger',
    beskrivelse: 'Boliger der administreres af en almen boligorganisation.',
  },
  {
    kode: 1160,
    tekst: 'Fællesanlæg',
    beskrivelse:
      "Anlæg der udnyttes og ejes af flere grundejere i fællesskab, fx arealer til ophold, tilkørsel og parkering, fælleshus, varmeforsyning mv. Ofte en 'naturlig' del af et boligområde. Registreres kun når det nævnes specifikt i planen.",
  },
  { kode: 2110, tekst: 'Blandet byområde', beskrivelse: '' },
  {
    kode: 2120,
    tekst: 'Landsbyområde',
    beskrivelse:
      'En mindre by på landet med forholdsvis tætliggende gårde og huse samt bygninger til fælles brug, fx evt. kirke og forsamlingshus samt i nogle tilfælde skole og butikker.',
  },
  {
    kode: 2130,
    tekst: 'Jordbrugsparceller',
    beskrivelse:
      "Omfatter såkaldte 'Jordbrugsparceller' efter historisk lovgivning, og kan således kun anvendes til registrering af eksisterende - ikke nye - planer. Nye planer med tilsvarende anvendelse, skal registreres under boligformål. OBS: Efter planlovens kan en lokalplan for landzonearealer, der – uden for landsbyer – fastlægges til jordbrugsmæssig anvendelse, ikke indeholde bestemmelser om ejendommes størrelse og afgrænsning, om bebyggelsers beliggenhed på grundene, om anvendelsen af de enkelte bygninger eller om udformning, anvendelse og vedligeholdelse af ubebyggede arealer mv.",
  },
  { kode: 2140, tekst: 'Blandet bolig og erhverv', beskrivelse: '' },
  {
    kode: 3100,
    tekst: 'Erhvervsområde',
    beskrivelse:
      'Uspecificeret erhvervsområde. Anvendes når planen ikke udpeger specifikke erhvervstyper.',
  },
  {
    kode: 3110,
    tekst: 'Kontor- og serviceerhverv',
    beskrivelse:
      'Administration og liberale erhverv (Klinik (læge, tandlæge og lign.), kontor (advokat, revisor, ejendomsmægler og lign.) og tegnestue (rådgivende ingeniør, arkitekt og reklamebureau og lign.)) samt fremstillingsvirksomhed og engroshandel, der udelukkende betjener sig af kontorlokaler. Omfatter ikke handel og transportvirksomhed.',
  },
  { kode: 3115, tekst: 'Industri', beskrivelse: '' },
  {
    kode: 3120,
    tekst: 'Let industri og håndværk',
    beskrivelse:
      'Lettere fremstillingvirksomhed. Ofte kaldet Industri- og værkstedsvirksomhed',
  },
  {
    kode: 3130,
    tekst: 'Tung industri',
    beskrivelse: 'Fremstillingsvirksomhed.',
  },
  {
    kode: 3140,
    tekst: 'Virksomheder med særlige beliggenhedskrav',
    beskrivelse:
      'Begrebet »virksomheder, der stiller særlige beliggenhedskrav«, skal ses i sammenhæng med miljøbeskyttelseslovens kap. 5. Udover særlig forurenende industrivirksomheder er det anlæg som f.eks. rensningsanlæg mv. (vandforurening), affaldsanlæg (luft, støj, jord, vand), lufthavne (støj), flyvepladser (støj), motorbaner, knallertbaner, skydebaner (støj), samt militære øvelsesterræner (støj).',
  },
  {
    kode: 3150,
    tekst: 'Havneerhvervsområde',
    beskrivelse:
      "Erhverv til havneformål samt områder til tilknyttede bygninger. Fx containerhavn, containerplads, trafik- og opmarchareal, industri-, værksteds- og oplagsvirksomhed, tekniske anlæg med tilknytning til en container-, massegods-, projektgods-, stykgods- og ro-ro havn, samt service, administration, fællesanlæg og lignende med driftsmæssig tilknytning til havnen. Rekreative formål (fx lystbåde) er IKKE omfattet (se 'lystbådehavn').",
  },
  {
    kode: 3155,
    tekst: 'Transport- og logistikvirksomheder',
    beskrivelse:
      'Transport og logistikvirksomheder herunder lagervirksomheder, og andre transporttunge virksomheder.',
  },
  { kode: 3160, tekst: 'Erhvervsområde', beskrivelse: '' },
  {
    kode: 3165,
    tekst: 'Produktionsvirksomhed',
    beskrivelse:
      'Produktionsvirksomheder defineres som virksomheder, der er omfattet af kravet om miljøgodkendelse eller om regelmæssige tilsyn. Dvs. virksomheder omfattet af godkendelsesbekendtgørelsen, virksomheder omfattet af maskinværkstedsbekendtgørelsen og virksomheder anført på brugerbetalingsbekendtgørelsens bilag 1, dog ikke husdyrbrug.',
  },
  {
    kode: 3166,
    tekst: 'Konsekvensområde omkring produktionsvirksomheder',
    beskrivelse:
      'Konsekvensområder kan sammenlignes med ”opmærksomhedszoner”, der anviser, hvor kommunen i sin planlægning skal være særlig opmærksom på produktionsvirksomheden. Indenfor konsekvensområder kan der stilles krav til f.eks. afværgeforanstaltninger når der sker en ændret arealanvendelse.',
  },
  {
    kode: 3167,
    tekst: 'Transformationsområde',
    beskrivelse:
      'Transformationsområde indenfor konsekvensområder omkring erhvervsområder forbeholdt produktionsvirksomheder. Der er tale om arealer belastet af støj fra produktionsvirksomheder over de vejledende grænseværdier med max 5 dB, og hvor der er særlige byudviklingsinteresser. Et transformationsområde er typisk et område, der består af ældre erhvervsområder i de centrale dele af byerne, hvor dele af erhvervsvirksomheder med tiden er udflyttet, f.eks. havneområder eller nedlagte slagterier og kraftværker.',
  },
  {
    kode: 3170,
    tekst: 'Byomdannelsesområde',
    beskrivelse:
      'Område hvor anvendelsen af bebyggelse og ubebyggede arealer til erhvervsformål, havneformål eller lignende aktiviteter skal ændres til boligformål, institutionsformål, centerformål, rekreative formål eller erhvervsformål, der er forenelige med anvendelse til boligformål',
  },
  {
    kode: 3180,
    tekst: 'Oplevelsesøkonomisk center',
    beskrivelse:
      'Oplevelsesøkonomiske centre er ofte turismefaciliteter kendetegnede ved at være større sammenhængende områder eller bygningsmasser, der kombinere en række forskellige aktiviteter og anlæg, fx rekreative tilbud, erhvervsaktivitet, detailhandel og restauration, og som markedsføres som en samlet destination, attraktion eller oplevelse. Egentlig detailhandel skal registreres særskilt jf. planloven.',
  },
  {
    kode: 3190,
    tekst: 'Fødevarevirksomhed med besøgsfaciliteter',
    beskrivelse:
      "Udpegningen knytter sig til planlovens mulighed for at fravige kravet om planlægning 'indefra og ud' hvor der er tale om eksisterende fødevarevirksomheder med besøgsfaciliteter, der bidrager til områdets turisme, og hvor en række yderligere vilkår er opfyldt.",
  },
  { kode: 4110, tekst: 'Bycenter', beskrivelse: '' },
  {
    kode: 4115,
    tekst: 'Bymidte',
    beskrivelse:
      'En del af detailhandelsstrukturen. Den centrale del af en by. Beliggenheden og afgrænsningen af bymidter skal tage udgangspunkt i tilstedeværelsen og koncentrationen af en række funktioner, herunder butikker, kulturtilbud, privat og offentlig service. Hver by kan kun have én bymidte.',
  },
  {
    kode: 4120,
    tekst: 'Bydelscenter',
    beskrivelse:
      'En del af detailhandelsstrukturen.  Bydelscentre udgør et centrum i en større bydel (I byer med 20.000 indbyggere og derover) og betjener bydelen med dagligvarer og de mest almindelige udvalgsvarer. Beliggenheden og afgrænsningen af bydelscentre skal tage udgangspunkt i tilstedeværelsen og koncentrationen af en række funktioner, herunder butikker, kulturtilbud, privat og offentlig service.',
  },
  {
    kode: 4130,
    tekst: 'Butikker til lokalområdets forsyning',
    beskrivelse:
      'En del af detailhandelsstrukturen. Enkeltstående butikker til lokalområdets daglige forsyning - primært butikker, der forhandler dagligvarer.',
  },
  { kode: 4135, tekst: 'Butikker', beskrivelse: '' },
  { kode: 4140, tekst: 'Område til butiksformål', beskrivelse: '' },
  { kode: 4150, tekst: 'Skilte/facade regulering', beskrivelse: '' },
  { kode: 4160, tekst: 'Bygningsbevarende regulerende', beskrivelse: '' },
  {
    kode: 4170,
    tekst: 'Lokalcenter',
    beskrivelse:
      'En del af detailhandelsstrukturen. Et lokalcenter betjener alene en begrænset del af en by eller en bydel, en landsby, et sommerhusområde eller lignende.',
  },
  {
    kode: 4175,
    tekst: 'Butikker med særligt pladskrævende varer',
    beskrivelse:
      'Arealer til butikker, der alene forhandler biler, lystbåde, campingvogne, planter, havebrugsvarer, tømmer, byggematerialer, grus, sten- og betonvarer samt møbler',
  },
  {
    kode: 4177,
    tekst: 'Tankstation',
    beskrivelse:
      "Tankstation, salg af brændstof til alm. kørertøjer, vaskeanlæg, kiosk m.m. Benyttes kun når planen udpeger område specifik til 'tankstation'.",
  },
  {
    kode: 4180,
    tekst: 'Publikumsorienterede serviceerhverv',
    beskrivelse:
      'Serviceerhverv som ikke er detailhandel, men som typisk placeres sammen med detailhandel og som på samme måde henvender sig åbent til et bredt publikum, eksempelvis caféer.',
  },
  {
    kode: 4190,
    tekst: 'Aflastningsområde',
    beskrivelse:
      'En del af detailhandelsstrukturen. Aflastningsområder har til formål at aflaste bymidten i byer, hvor der er et tilstrækkeligt kundegrundlag, ved bl.a. at give plads til butikker, som ikke uden videre kan placeres i bymidten – eksempelvis store udvalgsvarebutikker. Aflastningsområder kan ikke udlægges til én enkelt dagligvarebutik eller udelukkende dagligvarebutikker.',
  },
  {
    kode: 5110,
    tekst: 'Større rekreativt område',
    beskrivelse:
      'Større arealer til fritidsaktiviteter, grønne områder, parker mv., der retter sig mod et større opland. Omfatter ikke støjende fritids- og turistanlæg, kolonihaver, idrætsanlæg, lystbådehavne, feriecentre, campingpladser og forlystelsesanlæg mv., som er specificeret i egne katagorier.',
  },
  {
    kode: 5111,
    tekst: 'Koloni- og nyttehaver',
    beskrivelse:
      'Et areal, der omfatter mindst 5 havelodder og eventuelt et fællesareal, bl.a. på betingelse af, at arealet ligger i byzone eller landzone, at havelodderne i området i gennemsnit ikke er større end 400 m2, at bebyggelsen i området ikke må anvendes til helårsbeboelse, og at området ikke er en del af et friareal, der hører til en boligbebyggelse. Omfatter haveforeninger, kolonihaveforeninger, nyttehaveforeninger mv.',
  },
  {
    kode: 5115,
    tekst: 'Nærrekreativt område',
    beskrivelse:
      'Mindre friareal i tilknytning til eks. bolig eller offentlig institution; fritidsaktiviteter, legepladser, grønne områder mv. i nærheden af skole eller boligområde.',
  },
  {
    kode: 5116,
    tekst: 'Beplantning',
    beskrivelse:
      "Bestemmelser for hvordan et område skal tilplantes. Træer og buske der findes eller planlægges plantet i et område. Kan fx være et beplantningsbælte. Beplantning er ofte en 'naturlig' del af et bolig- eller erhvervsområde. Registreres kun, når beplantning nævnes ekplicit under anvendelsesbestemmelser i planen.",
  },
  {
    kode: 5117,
    tekst: 'Bevaringsværdig beplantning',
    beskrivelse:
      'Træer og anden beplantning, der er af særlig visuel, botanisk eller historisk betydning',
  },
  {
    kode: 5120,
    tekst: 'Sports- og idrætsanlæg',
    beskrivelse: 'Idræts- og sportsanlæg inkl. ridehal, ridestald og rideskole',
  },
  { kode: 5121, tekst: 'Golfbaneanlæg', beskrivelse: 'Golfbaner' },
  {
    kode: 5122,
    tekst: 'Støjende fritidsanlæg',
    beskrivelse:
      'Støjende fritids- og turistanlæg, inkl. forlystelsesanlæg så som sommerlande, motorbaner, skyderbaner m.v.',
  },
  { kode: 5123, tekst: 'Lystbådehavn', beskrivelse: 'Lystbådehavn' },
  {
    kode: 5130,
    tekst: 'Ferie- og kongrescenter',
    beskrivelse:
      'Større selvstændige virksomheder, der modtager overnattende gæster med mulighed for servering, fx morgenmad (hoteller med huse og hytter, eventuelt drevet under betegnelserne: kur- og wellnesscente, konferencecenter osv.). Omfatter også større område planlagt til en flerhed af ferieboligformer (hotel, campingplads m.m. – også benævnt ”resort”).',
  },
  { kode: 5131, tekst: 'Campingplads og vandrerhjem', beskrivelse: '' },
  {
    kode: 5140,
    tekst: 'Campingplads og vandrerhjem',
    beskrivelse: 'Campingplads, vandrehjem, ferikoloni m.m.',
  },
  { kode: 5150, tekst: 'Rekreativt område', beskrivelse: '' },
  {
    kode: 5190,
    tekst: 'Øvrige ferie- og fritidsformål',
    beskrivelse: 'Andre ferie- og fritidsformål.',
  },
  {
    kode: 6110,
    tekst: 'Sommerhus- og fritidsboligbebyggelse',
    beskrivelse: 'Område udlagt til sommerhusområde.',
  },
  {
    kode: 7100,
    tekst: 'Område til offentlige formål',
    beskrivelse:
      'Uspecificeret offentlige formål. Anvendes når planen ikke specificere offentlig formål.',
  },
  {
    kode: 7110,
    tekst: 'Uddannelsesinstitutioner',
    beskrivelse:
      'Uddannelsesinstitution eller uddannelsessted i form af offentlige og private skoler samt alle former for supplerende uddannelser og videregående uddannelser.',
  },
  {
    kode: 7120,
    tekst: 'Sundhedsinstitutioner',
    beskrivelse:
      'Hospitaler, sundhedsklinikker, jordemodercentre, fødeklinik, lægehus, sundhedscenter, hospice o. lign.',
  },
  { kode: 7130, tekst: 'Sociale institutioner', beskrivelse: '' },
  { kode: 7131, tekst: 'Institutioner', beskrivelse: '' },
  {
    kode: 7133,
    tekst: 'Daginstitutioner',
    beskrivelse:
      'Institution for børn eller voksne, der anvendes i dagtimerne. Omfatter f.eks. børneinstitutioner, fritidshjem, børnehus, skolefritidsordning (SFO), fritids- og ungdomsklub, dagcenter mv.',
  },
  {
    kode: 7135,
    tekst: 'Døgninstitutioner',
    beskrivelse:
      'Institution for børn eller voksne, der er døgnbemandet og typisk er af boliglignende karakter. Omfatter f.eks. døgninstitutioner, plejehjem og beskyttede boliger, forsorgshjem m.v.',
  },
  {
    kode: 7140,
    tekst: 'Kulturelle institutioner',
    beskrivelse: 'Biblioteker, museer',
  },
  {
    kode: 7150,
    tekst: 'Offentlig administration',
    beskrivelse: 'Offentlig administration (kommune, region, Stat)',
  },
  {
    kode: 7160,
    tekst: 'Religiøse institutioner og gravpladser',
    beskrivelse: 'Kirker og kirkegårde inkl. områder til tilknyttede bygninger',
  },
  { kode: 7170, tekst: 'Område til offentlige formål', beskrivelse: '' },
  {
    kode: 7180,
    tekst: 'Fængsler',
    beskrivelse: 'Fængsler, arresthuse o. lign.',
  },
  {
    kode: 8100,
    tekst: 'Tekniske anlæg',
    beskrivelse:
      'Uspecificeret Tekniske anlæg. Anvendes når planen ikke udpeger specifikke typer af tekniske anlæg.',
  },
  {
    kode: 8110,
    tekst: 'Forsyningsanlæg',
    beskrivelse:
      'Forsyningsanlæg og ledningsanlæg i tilknytning hertil (vand, varme, el, telekommunikation mv.). Biogasanlæg og solenergianlæg har egen kategori.',
  },
  {
    kode: 8111,
    tekst: 'Vindmølleanlæg',
    beskrivelse: 'Vindmøller og vindmølleparker',
  },
  {
    kode: 8112,
    tekst: 'Husstandsvindmølle',
    beskrivelse:
      'En mindre, enkeltstående vindmølle med en totalhøjde på under 25 meter. Opføres typisk i tilknytning til fritliggende ejendomme, og med den primære funktion, at levere energi til ejendommens eget forbrug – enten som elektricitet eller som varmt vand.',
  },
  {
    kode: 8120,
    tekst: 'Deponeringsanlæg',
    beskrivelse: 'Deponeringsanlæg, affaldsdepot m.v.',
  },
  {
    kode: 8130,
    tekst: 'Rensningsanlæg',
    beskrivelse: 'Affaldsbehandlingsanlæg (komposteringsanlæg m.v.)',
  },
  {
    kode: 8133,
    tekst: 'Solenergianlæg',
    beskrivelse: 'Fx solcellemarker, større solfangeranlæg mv.',
  },
  {
    kode: 8134,
    tekst: 'Regnvands- og klimaanlæg',
    beskrivelse:
      'Spildevands-, kloakerings-, regnvandsanlæg, regnvandsbassiner, oversvømmelsesanlæg m.m.',
  },
  { kode: 8140, tekst: 'Trafikanlæg', beskrivelse: '' },
  { kode: 8150, tekst: 'Tekniske anlæg', beskrivelse: '' },
  {
    kode: 8160,
    tekst: 'Biogasanlæg, Biogas anlæg, både fælles- og gårdanlæg',
    beskrivelse: '',
  },
  {
    kode: 8170,
    tekst: 'Landskabstekniske anlæg',
    beskrivelse:
      'Øvrige specificerede tekniske anlæg, fx støjskærm, mur, jordvold, jorddiger m.fl.',
  },
  {
    kode: 8180,
    tekst: 'Trafikanlæg',
    beskrivelse:
      'Uspecificeret trafikanlæg. Anvendes når planen ikke upeger specifikke trafikanlæg (i disse tilfælde skal alle de specifikke kategorier for bolig ikke markeres).',
  },
  { kode: 8181, tekst: 'Vejanlæg', beskrivelse: 'Områder til veje og broer' },
  {
    kode: 8182,
    tekst: 'Parkeringsanlæg',
    beskrivelse: 'Områder til parkeringspladser og parkeringshuse.',
  },
  { kode: 8183, tekst: 'Stianlæg', beskrivelse: 'Områder til stier' },
  {
    kode: 8185,
    tekst: 'Lufthavn',
    beskrivelse:
      'Områder til lufthavne, inkl. områder til tilknyttede bygninger',
  },
  {
    kode: 8186,
    tekst: 'Helikopterlandingsplads',
    beskrivelse:
      'Områder til helikoptorlandingsplads samt etablering af helikoptorlandingsplads på toppen af en bygning.',
  },
  {
    kode: 8190,
    tekst: 'Trafikterminal',
    beskrivelse:
      'Områder til trafikterminaler, inkl. stationer, busholdepladser og områder til tilknyttede bygninger.',
  },
  {
    kode: 8195,
    tekst: 'Transportkorridor',
    beskrivelse:
      'Arealreservation, fx et bånd på 1 km’s bredde, som sikrer mulighed for placering af fremtidige forsynings- og trafikanlæg (veje, baner, gasledninger, højspændingsledninger mv.)',
  },
  { kode: 9100, tekst: 'Landområde', beskrivelse: 'Uspecificeret landområde' },
  {
    kode: 9110,
    tekst: 'Jordbrugsområde',
    beskrivelse:
      'Område fastlagt til jordbrugsmæssig anvendelse med evt. tilhørende stuehus, alvs- og driftsbygninger, herunder gartnerier. OBS: Efter planlovens kan en lokalplan for landzonearealer, der – uden for landsbyer – fastlægges til jordbrugsmæssig anvendelse, ikke indeholde bestemmelser om ejendommes størrelse og afgrænsning, om bebyggelsers beliggenhed på grundene, om anvendelsen af de enkelte bygninger eller om udformning, anvendelse og vedligeholdelse af ubebyggede arealer mv.',
  },
  {
    kode: 9120,
    tekst: 'Naturområde',
    beskrivelse:
      'Områder af særlig betydning for planter og vilde dyr og deres levesteder samt områder, der er af landskabelig, kulturhistorisk, naturvidenskabelig og undervisningsmæssig værdi.',
  },
  {
    kode: 9125,
    tekst: 'Faunapassage',
    beskrivelse:
      'Bro, tunnel eller lign., som gør det muligt for dyr at passere en forhindring, fx en vej eller et vandløb.',
  },
  {
    kode: 9130,
    tekst: 'Militære anlæg',
    beskrivelse:
      'Forsvarets, hjemmeværnets og beredskabets operations-, trænings- og uddannelsesfaciliteter. Omfatter f.eks. radarer , flyvestationer, flådestationer, kaserner, depoter, skydebaner og skyde- og øvelsesterræner.',
  },
  {
    kode: 9140,
    tekst: 'Råstofindvinding',
    beskrivelse: 'Område til indvinding af råstoffer Fx grusgrav',
  },
  { kode: 9150, tekst: 'Landområder', beskrivelse: '' },
  {
    kode: 9170,
    tekst: 'Industrielt landbrug',
    beskrivelse:
      'Intensivt husdyrbrug: Fx: Større anlæg til svineproduktion eller andre avls- og driftsbygninger til landbrug, som har størrelser, der svarer til fabriksproduktion. OBS: Efter planlovens kan en lokalplan for landzonearealer, der – uden for landsbyer – fastlægges til jordbrugsmæssig anvendelse, ikke indeholde bestemmelser om ejendommes størrelse og afgrænsning, om bebyggelsers beliggenhed på grundene, om anvendelsen af de enkelte bygninger eller om udformning, anvendelse og vedligeholdelse af ubebyggede arealer mv.',
  },
  { kode: 9610, tekst: 'Andet', beskrivelse: '' },
];

export function getAnvspecForKode(kode: number): Kode | undefined {
  return anvspec.find(function(a) {
    return a.kode === kode;
  });
}
